import instantsearch from 'instantsearch.js/dist/instantsearch.js';
import * as searcher from './searchWidgets';

const UPCOMING_INDEX = 'EventUpcoming';
const POPULAR_INDEX = 'EventPopular';
const DEFAULT_INDEX = 'EventUpcoming';
const RESULTS_PER_PAGE = 9;
const RESULTS_ID = '#eventSearchResults';
const RESULTS_ELEM = $(RESULTS_ID);

let search;
let resultCount;
let eventFilterString = '';

/**
 * Set up and start filtering on event pages
 */
if (RESULTS_ELEM.length) {
    setFilters();
    createSearch();
    initListeners();
    startSearch();
}

function setFilters() {
    const today = Math.floor((new Date().setHours(0,0,0,0))/1000);
    const filterTypes = RESULTS_ELEM.data('search-types') || [];
    const filterTopics = RESULTS_ELEM.data('search-topics') || [];
    const customFilter = RESULTS_ELEM.data('search-custom-filter');

    // Upcoming events only
    const eventFilters = [`(EndDate >= ${today} OR Date >= ${today})`]

    if (customFilter) {
        eventFilters.push(customFilter);
    }

    filterTypes.forEach((filterType) => {
        eventFilters.push(`(Type:"${filterType}")`);
    });

    filterTopics.forEach((filterTopic) => {
        eventFilters.push(`(Topic:"${filterType}")`);
    });

    eventFilterString = eventFilters.join(' AND ');
}

/**
 * Create and start a filtered InstantSearch search
 */
function createSearch() {
    search = searcher.getSearch(DEFAULT_INDEX, RESULTS_PER_PAGE, true, eventFilterString);

    search.addWidget(
        searcher.widgetFilterEventHits(RESULTS_ID, function(){
            checkResultCount();
        })
    );

    search.addWidget(
        searcher.widgetRefinementList('#facetType  .SearchFilter-group-items', 'Type')
    );

    search.addWidget(
        searcher.widgetRefinementList('#facetTopic  .SearchFilter-group-items', 'Topic')
    );

    search.addWidget(
        searcher.widgetRegionList('#facetRegion  .SearchFilter-group-items', 'Region')
    );

    search.start();
}


/**
 * Sets up listeners for various sections of the filter page to
 * give a more interactive and useful filter experience.
 */

function initListeners() {
    // display most recent index results
    $('.js-search-sort-recent').change(function() {
        search.helper.state.index = searcher.getIndex(UPCOMING_INDEX);
        search.helper.search();
        $('.js-search-sort-label').text('Most recent');
    });

    // display most popular index results
    $('.js-search-sort-popular').change(function() {
        search.helper.state.index = searcher.getIndex(POPULAR_INDEX);
        search.helper.search();
        $('.js-search-sort-label').text('Most popular');
    });

    // show empty regions in filter
    var predefRegions = ["auckland" ,"bay-of-plenty" ,"canterbury" ,"hawkes-bay" ,"manawatu" ,"nelson" ,"northland" ,"online" ,"otago" ,"taranaki" ,"waikato" ,"wellington"];

    const facetChange = function() {
        for(let i = 0; i < predefRegions.length; i++){
            var predefRegion = predefRegions[i];
            if ( $(".regioncheck-"+predefRegion).length ) {
                $("#empty-region-"+predefRegion).hide();
            } else {
                $("#empty-region-"+predefRegion).show();
            }
        }
    }

    $('#facetType').change(facetChange);
    $('#facetTopic').change(facetChange);
    $('#facetRegion').click(facetChange);

    // see more button with max results
    $('#seeMoreBtn').click(function(e) {
        search.helper.state.hitsPerPage += 4;
        search.helper.search();
        checkResultCount();
        e.preventDefault();
    });
}


/**
 * Show/display the show more button when appropriate.
 * Display no results message if there are no results.
 */
function checkResultCount() {
    // initialise count to 0 since lastResults doesn't seem to be accessible when there are no results or
    // something like that. console.log(search.helper.lastResults) is null even when lastResults exists in
    // console.log(search.helper)
    resultCount = 0;

    if (search.helper.lastResults) {
        resultCount = search.helper.lastResults.nbHits;
    }

    // show hide no results message
    if (resultCount === 0) {
        $('.js-empty-search-results').show();
    } else {
        $('.js-empty-search-results').hide();
    }

    if ((!resultCount && search.helper.lastResults) ||
        search.helper.state.hitsPerPage >= resultCount ) {
            $('#seeMoreBtn').css('display', 'none');
    } else {
        $('#seeMoreBtn').css('display', 'block');
    }
}

function startSearch() {
    search.helper.state.filters = eventFilterString;
    search.helper.search();
    checkResultCount();
}



// WEBPACK FOOTER //
// ./src/js/search/eventHolderFilters.js